import { useLang } from "@/context/LanguageContext";
import { PageHead } from "@/components/Shared";

const titles = {
  privacy: { en: "Privacy Policy", nl: "Privacybeleid" },
  terms: { en: "Terms & Conditions", nl: "Algemene voorwaarden" },
  cookies: { en: "Cookie Policy", nl: "Cookiebeleid" },
};

export default function LegalPage({ kind }) {
  const { lang } = useLang();
  const title = titles[kind][lang];
  const note = lang === "nl"
    ? "Deze pagina is een bewerkbare placeholder. Definitieve juridische tekst wordt door Maison Core aangeleverd en vormt geen juridisch advies."
    : "This page is an editable placeholder. Final legal copy will be supplied by Maison Core and does not constitute legal advice.";
  return (
    <>
      <PageHead label="Legal" title={title} />
      <section className="bg-petal" data-testid={`legal-${kind}`}>
        <div className="mx-auto max-w-3xl px-6 py-20 md:px-12 md:py-28">
          <p className="font-sans text-lg italic leading-relaxed text-onyx/50">{note}</p>
        </div>
      </section>
    </>
  );
}
